<template>
  <div id="theme-customizer" v-if="active">
    <vs-sidebar
      click-not-close
      hidden-background
      position-right
      v-model="active"
      class="items-no-padding">
      <div class="h-full">
        <div class="customizer-header mt-6 flex items-center justify-between px-6">
          <div>
            <h4>{{ chart_name }} Configs</h4>
          </div>
          <feather-icon icon="XIcon" @click.stop="active = false" class="cursor-pointer"></feather-icon>
        </div>

        <vs-divider class="mb-0"/>

        <div class="vx-row mb-3 mt-4 px-4">
          <div class="vx-col md:FULL w-full md:mb-0">
            <small class="label">Chart Name</small>
            <vs-input v-model="chart_name"  name="xaxis_title" class="w-full required" label=""/>
          </div>
        </div>
        <div class="vx-row mb-8 px-4" v-if="report_type !== 'table'">
          <div class="vx-col md:full w-full md:mb-0">
            <small class="label">Chart Type</small>
            <v-select :clearable="false" placeholder="" v-model="chart_type"
                      :options="['line', 'bar', 'area', 'scatter', 'pie']"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
          </div>
        </div>

        <div class="vx-row my-3 mx-0" v-if="['line', 'area'].includes(chart_type)">
          <div class="vx-col w-full">
            <small> Line stroke</small>
            <ul class="mt-4">
              <li class="inline-block mr-4">
                <vs-radio v-model="chart_configs.stroke.curve" vs-value="smooth">Smooth</vs-radio>
              </li>
              <li class="inline-block mr-4">
                <vs-radio v-model="chart_configs.stroke.curve" vs-value="straight">Straight</vs-radio>
              </li>
              <li class="inline-block mr-4">
                <vs-radio v-model="chart_configs.stroke.curve" vs-value="stepline">Step Line</vs-radio>
              </li>
            </ul>
          </div>
        </div>

        <div class="vx-row my-3 px-4" v-if="chart_type !== 'pie' && report_type !== 'table'">
          <div class="vx-col md:FULL w-full md:mb-0">
            <small class="label">Line color</small>
            <input v-model="chart_configs.colors[0]" type="color" class="w-full required mt-2">
          </div>
        </div>

        <div class="vx-row my-3 px-4" v-if="['line'].includes(chart_type)">
          <div class="vx-col md:FULL w-full md:mb-0">
            <small class="label">Line width (px)</small>
            <vs-input v-model="chart_configs.stroke.width"  name="stroke_width" class="w-full required" label=""/>
          </div>
        </div>

        <div class="vx-row my-3 px-4" v-if="chart_type !== 'pie' && report_type !== 'table'">
          <div class="vx-col md:FULL w-full md:mb-0">
              <small class="label">X axis title</small>
              <vs-input v-model="chart_configs.xaxis.title.text"  name="xaxis_title" class="w-full required" label=""/>
          </div>
        </div>
        <div class="vx-row mb-3 px-4" v-if="chart_type !== 'pie' && report_type !== 'table' ">
          <div class="vx-col md:FULL w-full md:mb-0">
            <small class="label">Y axis title</small>
            <vs-input v-model="chart_configs.yaxis.title.text"  name="yaxis_title" class="w-full required" label=""/>
          </div>
        </div>
        <div class="vx-row mb-3 px-4" v-if="chart_type !== 'pie' && report_type !== 'table'">
          <div class="vx-col md:FULL w-full md:mb-0">
            <small class="label">Y-axis Tick Amounts</small>
            <vs-input v-model="chart_configs.yaxis.tickAmount"  name="y_tickAmount" class="w-full required" label=""/>
          </div>
        </div>

        <div class="vx-row my-3 mx-0" v-if="chart_type !== 'pie' && report_type !== 'table'">
          <div class="vx-col w-1/4">
            <small>X axis grid</small>
            <vs-switch color="success" v-model="chart_configs.grid.xaxis.lines.show" />
          </div>
          <div class="vx-col w-1/4">
            <small>Y axis grid</small>
            <vs-switch color="success" v-model="chart_configs.grid.yaxis.lines.show" />
          </div>
        </div>

        <div class="vx-row mb-3 px-4" v-if="report_type !== 'table'">
          <div class="vx-col md:full w-full md:mb-0">
            <small class="label">Interval</small>
            <v-select :clearable="false" placeholder="" v-model="report_data.interval"
                      :options="['daily', 'weekly', 'monthly']"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
          </div>
        </div>
        <div class="vx-row mb-3 px-4">
          <div class="vx-col md:full w-full md:mb-0">
            <small class="label">Range</small>
            <v-select :clearable="false" placeholder="" v-model="report_data.range"
                      :options="range_list"
                      label="label"
                      :reduce="option => option.value"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
          </div>
        </div>

        <div class="vx-row my-5 mx-3">
          <div class="vx-col w-full ml-auto">
            <vs-button @click.stop="onClickSave" class="float-right w-full my-4" size="small" color="primary"
                       type="border" icon-pack="feather" icon="icon-save">UPDATE
            </vs-button>
          </div>
        </div>

      </div>
    </vs-sidebar>
  </div>
</template>


<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import chart_data from "@/constants/charts";


import {RepositoryFactory} from "@/repository/RepositoryFactory";
import ErrorMessages from "@/mixins/ErrorMessages";
import SuccessMessage from "@/mixins/SuccessMessage";
const ReportingRepository = RepositoryFactory.get('reporting');

export default {
  name: 'ChartConfigsSideBar',
  data() {
    return {
      active: false,
      id: '',
      chart_type: '',
      chart_configs: {},
      chart_name: '',
      report_type:'',
      report_data: {},
      range_list: [
        {label: 'This Month', value: '30'},
        {label: 'Previous Month', value: '60'},
        {label: 'This Quarter', value: '90'},
        {label: 'Previous Quarter', value: '180'},
        {label: 'This Year', value: '365'},
        {label: 'Previous Year', value: '600'},
      ],
      chart_data,
      existing_chart_type: '',
    }
  },
  mounted(){

  },
  mixins: [ErrorMessages, SuccessMessage],
  methods: {
    openSideBar(report_data) {
      this.id = report_data.id
      this.chart_name= report_data.chart_name
      this.chart_configs= report_data.configs
      this.existing_chart_type = report_data.chart_type
      this.chart_type= report_data.chart_type
      this.report_type = report_data.report_type
      this.report_data = report_data

      setTimeout(() => {
        this.active = true
      }, 10)
    },
    async onClickSave() {
      let payload = {}

      if(this.report_type !== 'table') {
        if (this.chart_type !== 'pie') {
          payload.configs = this.chart_configs
          payload.yaxis = this.chart_configs.yaxis.title.text
          payload.xaxis = this.chart_configs.xaxis.title.text
          payload.chart_name = this.chart_name
          payload.chart_type = this.chart_type

          payload.filters = this.report_data.filters
          payload.range = this.report_data.range
          payload.interval = this.report_data.interval
          payload.endpoint = this.report_data.endpoint

          payload.actual_name = this.report_data.actual_name
        }

        if (this.chart_type === 'pie') {
          payload.configs = this.chart_configs
          payload.yaxis = this.report_data.yaxis
          payload.xaxis = this.report_data.xaxis
          payload.chart_name = this.chart_name
          payload.chart_type = this.chart_type

          payload.filters = this.report_data.filters
          payload.range = this.report_data.range
          payload.interval = this.report_data.interval
          payload.endpoint = this.report_data.endpoint

          payload.actual_name = this.report_data.actual_name
        }
      }else {
        payload.configs = this.chart_configs
        payload.chart_name = this.chart_name
        payload.filters = this.report_data.filters
        payload.range = this.report_data.range
        payload.interval = this.report_data.interval
        payload.endpoint = this.report_data.endpoint
        payload.actual_name = this.report_data.actual_name
      }

      try {
        await ReportingRepository.updateChart(this.id, payload)
        this.showSuccessMessage('Chart update successfully')
        this.$emit('refresh-chart-list')
        this.active = false
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      // this.active = false
      // this.$emit('saveConfig', { type: this.chart_type, config: this.chart_configs })
    }
  },
  watch: {
    'chart_type' : {
      handler: function (newVal, oldVal) {
        if(newVal === 'pie' && oldVal) {
          this.chart_configs = this.chart_data.pie_chart_data.chart_options
        }
        if(newVal !== 'pie' && oldVal === 'pie') {
          this.chart_configs = this.chart_data.line_chart_data.chart_options
        }
      },
      deep: true,
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
  },
}

</script>


<style lang="scss">
#theme-customizer {
  .vs-sidebar {
    position: fixed;
    z-index: 52000;
    width: 400px;
    max-width: 90vw;
    // @apply shadow-lg;
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11), 0 5px 15px 0 rgba(0, 0, 0, 0.08);
  }
}

.customizer-btn {
  position: fixed;
  top: 10%;
  right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  z-index: 50000;

  /*.vs-icon {*/
  /*  animation: spin 1.5s linear infinite;*/
  /*}*/
}

.scroll-area--customizer {
  height: calc(100% - 5rem);

  &:not(.ps) {
    overflow-y: auto;
  }
}

.scroll-area {
  position: relative;
  margin: auto;
  width: 1000px;
  height: 1000px;
}
</style>

